import { TiersPartie } from '@core-lib/enums';
import { camelCaseToPascalCase } from '@core-lib/functions/utils.function';
import { IDegreRisque, IDepartement, INatureAffaire, IPays } from '@core-lib/models';

export function getNatureAffairePartieLibelle(nature: INatureAffaire, partie: TiersPartie): string {
	return (
		(nature && camelCaseToPascalCase(partie === TiersPartie.Partie1 ? nature.libellePartie1 : nature.libellePartie2)) ||
		(partie === TiersPartie.Partie1 ? 'ClientVendeur' : 'AdversaireAcquereur')
	);
}

export function getPaysProvenanceById(paysId: IPays['id'], pays: IPays[]): IPays {
	return pays.find(p => p.id === paysId);
}

export function getDepartementProvenanceById(departementId: IDepartement['id'], departements: IDepartement[]): IDepartement {
	return departements.find(d => d.id === departementId);
}

export function getNatureAffaireById(natureAffaireId: INatureAffaire['id'], natureAffaires: INatureAffaire[]): INatureAffaire {
	return natureAffaires?.find(n => n.id === natureAffaireId);
}

export function getDegreRisqueByNatureAffaireId(natureAffaireId: INatureAffaire['id'], natureAffaires: INatureAffaire[]): IDegreRisque {
	return natureAffaires?.find(n => n.id === natureAffaireId)?.degreRisque;
}

export function getArchivageMessage(result: any): string {
    let message = `${result.affairesArchivees + result.jumellesAffairesArchivees} affaire(s) archivée(s) / ${result.totalAffairesSelectionnees} affaire(s) sélectionnée(s).<br>`;
	if (result.affairesAlreadyArchived > 0) {
		message += `Archivage impossible pour ${result.affairesAlreadyArchived} affaire(s) : elles sont déja archivées.<br>`;
	}
    if (result.affairesSoldeComptableKo > 0) {
        message += `Archivage impossible pour ${result.affairesSoldeComptableKo} affaire(s) : il existe au moins une affaire créditrice.<br>`;
    }	
    if (result.affairesNonRapproKo > 0) {
        message += `Archivage impossible pour ${result.affairesNonRapproKo} affaire(s) : il existe au moins une affaire avec des mouvements en attente de rapprochement.<br>`;
    }
    if (result.jumellesSoldeComptableKo > 0) {
        message += `Archivage impossible pour ${result.jumellesSoldeComptableKo} affaire(s) : il existe au moins une affaire liée Article 15/Voies d'exécution créditrice.<br>`;
    }
    if (result.jumellesNonRapproKo > 0) {
        message += `Archivage impossible pour ${result.jumellesNonRapproKo} affaire(s) : il existe au moins une affaire liée Article 15/Voies d'exécution avec des mouvements en attente de rapprochement.<br>`;
    }

    return message;
}

export function getTextKeySingleArchivage(result: any): string {
	if (result.totalAffairesSelectionnees !== 1) {
		return '';
	}

	switch (true) {
		case result.affairesArchivees === 1:
			return 'AffaireArchiveeOK';
		case result.jumellesAffairesArchivees === 1:
			return 'AffaireArchiveeJumellesOK';
		case result.affairesAlreadyArchived === 1:
			return 'AffaireAlreadyArchiveeOK';
		case result.affairesSoldeComptableKo === 1:
			return 'AffaireArchivageImpossibleSoldeComptableKO';
		case result.affairesNonRapproKo === 1:
			return 'AffaireArchivageImpossibleSoldeBancaireKO';
		case result.jumellesSoldeComptableKo === 1:
			return 'AffaireJumelleArchivageImpossibleSoldeComptableKO';
		case result.jumellesNonRapproKo === 1:
			return 'AffaireJumelleArchivageImpossibleSoldeBancaireKO';
		case result.hasDemandeRibInProcessKo === 1:
			return 'ArchivageDemandeRibImpossibleInProcessKO';
		default:
			return '';
	}
}

